import { S01MailchimpNewsletterSignup } from "hyam-prismic/components/slices/S01MailchimpNewsletterSignup";
export default S01MailchimpNewsletterSignup;
